export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_rptCostMonth') || '发生月份',
    field: 'rptCostMonth',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_requestDepName') || '申请部门',
    field: 'requestDepName',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_requestOrgName') || '申请公司',
    field: 'requestOrgName',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_expenseTypeName') || '财务费用',
    field: 'expenseTypeName',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_rmbAmount') || '人民币金额',
    field: 'rmbAmount',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_usdAmount') || '美元金额',
    field: 'usdAmount',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_costDepName') || '分摊部门',
    field: 'costDepName',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_costOrgName') || '分摊公司',
    field: 'costOrgName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_updateTime') || '生成时间',
    field: 'updateTime',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
